import { useState } from "react";
import { FormTextInput } from "../Components/FormTextInput";
import SelectClient from "../Screens/Quote/QuoteComponents/SelectClient";

const SelectMemberTab = ({members, setSelectedMember, selectedMember, input1Placeholder = "Enter name for the Weekly Invoice", input2Placeholder = "Enter email for the Weekly Invoice"}) => {
    const [selectedMemberTab, setSelectedMemberTab] = useState("existing");

    return (
      <div className="w-full flex flex-col gap-3">
        <div className="flex flex-row justify-center items-center rounded-md overflow-hidden">
          <div className={`px-2 py-1 bg-[#F0F0F0] text-sm font-medium flex-1 text-center cursor-pointer ${selectedMemberTab === "existing" ? "text-black" : "text-gray-500"}`} 
          onClick={() => setSelectedMemberTab("existing")}>Existing</div>
          <div className={`px-2 py-1 bg-[#F0F0F0] text-sm font-medium flex-1 text-center cursor-pointer ${selectedMemberTab === "new" ? "text-black" : "text-gray-500"}`}
          onClick={() => setSelectedMemberTab("new")}>New Email</div>
        </div>
        {selectedMemberTab === "new" && (
          <div className="w-full flex flex-col gap-2">
            <FormTextInput
              placeholder={input1Placeholder}
              value={selectedMember?.name}
              onChange={(value) => setSelectedMember({...selectedMember, name: value})}
            />
            <FormTextInput
                placeholder={input2Placeholder}
                value={selectedMember?.email}
                onChange={(value) => setSelectedMember({...selectedMember, email: value})}
              />
          </div>
        )}
        {selectedMemberTab === "existing" && (
          <div className="w-full flex flex-col gap-2">
              <SelectClient
                customClass={"w-full"}
                placeholder={"Choose Member"}
                clients={members}
                handleSelectedClient={(selectedTeamData) => setSelectedMember(selectedTeamData)}
                defaultSelecedClient={selectedMember}
              />
          </div>
        )}
      </div>
    )
  }

  export default SelectMemberTab;